import {
  createQuestionEntry as publicCreateQuestionEntry,
  getQuestionEntry as publicGetQuestionEntry,
  updateQuestionEntry as publicUpdateQuestionEntry,
  deleteQuestionEntry as publicDeleteQuestionEntry,
  listQuestionEntries as publicListQuestionEntries,
  queryQuestionEntries as publicQueryQuestionEntries,
  typedQueryQuestionEntries as publicTypedQueryQuestionEntries,
  bulkDeleteQuestionEntries as publicBulkDeleteQuestionEntries,
  updateExtendedFields as publicUpdateExtendedFields,
  setQuestionEntryLabels as publicSetQuestionEntryLabels,
  bulkUpdateQuestionEntry as publicBulkUpdateQuestionEntry,
} from './faq-question-entry-v2-question-entry-question-entry.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryQuestionEntriesOptions,
  QuestionEntriesQueryBuilder,
  QuestionEntryQuery,
  typedQueryQuestionEntries as universalTypedQueryQuestionEntries,
} from './faq-question-entry-v2-question-entry-question-entry.universal.js';
import { onQuestionEntryCreated as publicOnQuestionEntryCreated } from './faq-question-entry-v2-question-entry-question-entry.public.js';
import { onQuestionEntryDeleted as publicOnQuestionEntryDeleted } from './faq-question-entry-v2-question-entry-question-entry.public.js';
import { onQuestionEntryUpdated as publicOnQuestionEntryUpdated } from './faq-question-entry-v2-question-entry-question-entry.public.js';

function customQueryQuestionEntries(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryQuestionEntriesOptions) =>
      publicQueryQuestionEntries(httpClient)(options),
    typedQueryFunction: (
      query: QuestionEntryQuery,
      options?: QueryQuestionEntriesOptions
    ) => publicTypedQueryQuestionEntries(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: QuestionEntryQuery,
    options?: QueryQuestionEntriesOptions
  ): ReturnType<typeof universalTypedQueryQuestionEntries>;
  function overloadedQuery(
    options?: QueryQuestionEntriesOptions
  ): QuestionEntriesQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: QuestionEntryQuery | QueryQuestionEntriesOptions,
    options?: QueryQuestionEntriesOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createQuestionEntry: MaybeContext<
  BuildRESTFunction<typeof publicCreateQuestionEntry> &
    typeof publicCreateQuestionEntry
> = /*#__PURE__*/ createRESTModule(publicCreateQuestionEntry);
export const getQuestionEntry: MaybeContext<
  BuildRESTFunction<typeof publicGetQuestionEntry> &
    typeof publicGetQuestionEntry
> = /*#__PURE__*/ createRESTModule(publicGetQuestionEntry);
export const updateQuestionEntry: MaybeContext<
  BuildRESTFunction<typeof publicUpdateQuestionEntry> &
    typeof publicUpdateQuestionEntry
> = /*#__PURE__*/ createRESTModule(publicUpdateQuestionEntry);
export const deleteQuestionEntry: MaybeContext<
  BuildRESTFunction<typeof publicDeleteQuestionEntry> &
    typeof publicDeleteQuestionEntry
> = /*#__PURE__*/ createRESTModule(publicDeleteQuestionEntry);
export const listQuestionEntries: MaybeContext<
  BuildRESTFunction<typeof publicListQuestionEntries> &
    typeof publicListQuestionEntries
> = /*#__PURE__*/ createRESTModule(publicListQuestionEntries);
export const bulkDeleteQuestionEntries: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteQuestionEntries> &
    typeof publicBulkDeleteQuestionEntries
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteQuestionEntries);
export const updateExtendedFields: MaybeContext<
  BuildRESTFunction<typeof publicUpdateExtendedFields> &
    typeof publicUpdateExtendedFields
> = /*#__PURE__*/ createRESTModule(publicUpdateExtendedFields);
export const setQuestionEntryLabels: MaybeContext<
  BuildRESTFunction<typeof publicSetQuestionEntryLabels> &
    typeof publicSetQuestionEntryLabels
> = /*#__PURE__*/ createRESTModule(publicSetQuestionEntryLabels);
export const bulkUpdateQuestionEntry: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateQuestionEntry> &
    typeof publicBulkUpdateQuestionEntry
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateQuestionEntry);
export const queryQuestionEntries: MaybeContext<
  BuildRESTFunction<typeof customQueryQuestionEntries> &
    typeof customQueryQuestionEntries
> = /*#__PURE__*/ createRESTModule(customQueryQuestionEntries);
/**
 * Triggered when a question entry is created.
 */
export const onQuestionEntryCreated: BuildEventDefinition<
  typeof publicOnQuestionEntryCreated
> &
  typeof publicOnQuestionEntryCreated = /*#__PURE__*/ createEventModule(
  publicOnQuestionEntryCreated
);
/** */
export const onQuestionEntryDeleted: BuildEventDefinition<
  typeof publicOnQuestionEntryDeleted
> &
  typeof publicOnQuestionEntryDeleted = /*#__PURE__*/ createEventModule(
  publicOnQuestionEntryDeleted
);
/**
 * Triggered when a question entry is updated.
 */
export const onQuestionEntryUpdated: BuildEventDefinition<
  typeof publicOnQuestionEntryUpdated
> &
  typeof publicOnQuestionEntryUpdated = /*#__PURE__*/ createEventModule(
  publicOnQuestionEntryUpdated
);

export {
  NodeType,
  BackgroundType,
  GradientType,
  WidthType,
  PluginContainerDataAlignment,
  ButtonDataType,
  Target,
  Type,
  EntranceEffectType,
  LoopEffectType,
  PointerEffectType,
  TextAlignment,
  LineCap,
  LineStyle,
  Width,
  DividerDataAlignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  StylesPosition,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  PollDesignBackgroundType,
  DecorationType,
  ColorDataBackgroundType,
  FontType,
  Variant,
  Position,
  AspectRatio,
  Resizing,
  Placement,
  CardStylesType,
  Alignment,
  Layout,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  ImageScalingScaling,
  ImagePosition,
  LayoutDataBackgroundType,
  Origin,
  BannerPosition,
  LayerEffect,
  Shape,
  BackdropType,
  VerticalAlignmentAlignment,
  ResponsivenessBehaviour,
  DesignTarget,
  Scaling,
  ImagePositionPosition,
  CardDataBackgroundType,
  ListStyle,
  Indentation,
  SmartBlockDataType,
  ColumnSize,
  QuestionStatus,
  ContentFormat,
  FieldSet,
  SortOrder,
  QueryQuestionEntriesRequestContentFormat,
  QueryQuestionEntriesRequestFieldSet,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './faq-question-entry-v2-question-entry-question-entry.universal.js';
export {
  QuestionEntry,
  QuestionEntryAnswerOneOf,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Gradient,
  Stop,
  Border,
  Colors,
  Background,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  Animation,
  EntranceAnimation,
  EntranceEffect,
  LoopAnimation,
  LoopEffect,
  PointerEffect,
  CodeBlockData,
  TextStyle,
  DividerData,
  DividerDataStyles,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  GalleryOptionsLayout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  ImageDataCrop,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  Settings,
  PollLayout,
  OptionLayout,
  BackgroundGradient,
  PollDesignBackground,
  PollDesignBackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  ColorDataBackground,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  FontFamilyData,
  SketchData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  ButtonStyles,
  ImageStyles,
  RibbonStyles,
  CardStyles,
  PricingData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  BorderWidths,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutData,
  LayoutDataBackground,
  Layers,
  LayoutDataBackgroundImage,
  Banner,
  Backdrop,
  SectionDivider,
  LayoutCellData,
  ShapeData,
  ShapeDataStyles,
  CardData,
  CardDataBackground,
  BackgroundImage,
  TocData,
  SmartBlockData,
  SmartBlockCellData,
  CheckboxListData,
  ListItemNodeData,
  SlotData,
  SlotDesign,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  Label,
  ExtendedFields,
  CreateQuestionEntryRequest,
  CreateQuestionEntryResponse,
  GetQuestionEntryRequest,
  GetQuestionEntryResponse,
  UpdateQuestionEntryRequest,
  UpdateQuestionEntryResponse,
  DeleteQuestionEntryRequest,
  DeleteQuestionEntryResponse,
  ListQuestionEntriesRequest,
  CursorPaging,
  ListQuestionEntriesResponse,
  PagingMetadataV2,
  Cursors,
  QueryQuestionEntriesRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  AddressLocation,
  QueryQuestionEntriesResponse,
  CursorPagingMetadata,
  BulkDeleteQuestionEntriesRequest,
  BulkDeleteQuestionEntriesResponse,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  UpdateExtendedFieldsRequest,
  UpdateExtendedFieldsResponse,
  SetQuestionEntryLabelsRequest,
  SetQuestionEntryLabelsResponse,
  BulkUpdateQuestionEntryRequest,
  MaskedQuestionEntry,
  BulkUpdateQuestionEntryResponse,
  BulkUpdateQuestionEntryResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  EditorlessAssigned,
  EditorlessUnassigned,
  RunInstallationContentRequest,
  RunInstallationContentResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  QuestionEntryCreatedEnvelope,
  QuestionEntryDeletedEnvelope,
  QuestionEntryUpdatedEnvelope,
  UpdateQuestionEntry,
  ListQuestionEntriesOptions,
  QueryQuestionEntriesOptions,
  QuestionEntriesQueryResult,
  QuestionEntriesQueryBuilder,
  QuestionEntryQuerySpec,
  UpdateExtendedFieldsOptions,
  SetQuestionEntryLabelsOptions,
  BulkUpdateQuestionEntryOptions,
} from './faq-question-entry-v2-question-entry-question-entry.universal.js';
export { utils } from './faq-question-entry-v2-question-entry-question-entry.universal.js';
export {
  NodeTypeWithLiterals,
  BackgroundTypeWithLiterals,
  GradientTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  ButtonDataTypeWithLiterals,
  TargetWithLiterals,
  TypeWithLiterals,
  EntranceEffectTypeWithLiterals,
  LoopEffectTypeWithLiterals,
  PointerEffectTypeWithLiterals,
  TextAlignmentWithLiterals,
  LineCapWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  DividerDataAlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  StylesPositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  PollDesignBackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  ColorDataBackgroundTypeWithLiterals,
  FontTypeWithLiterals,
  VariantWithLiterals,
  PositionWithLiterals,
  AspectRatioWithLiterals,
  ResizingWithLiterals,
  PlacementWithLiterals,
  CardStylesTypeWithLiterals,
  AlignmentWithLiterals,
  LayoutWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  ImageScalingScalingWithLiterals,
  ImagePositionWithLiterals,
  LayoutDataBackgroundTypeWithLiterals,
  OriginWithLiterals,
  BannerPositionWithLiterals,
  LayerEffectWithLiterals,
  ShapeWithLiterals,
  BackdropTypeWithLiterals,
  VerticalAlignmentAlignmentWithLiterals,
  ResponsivenessBehaviourWithLiterals,
  DesignTargetWithLiterals,
  ScalingWithLiterals,
  ImagePositionPositionWithLiterals,
  CardDataBackgroundTypeWithLiterals,
  ListStyleWithLiterals,
  IndentationWithLiterals,
  SmartBlockDataTypeWithLiterals,
  ColumnSizeWithLiterals,
  QuestionStatusWithLiterals,
  ContentFormatWithLiterals,
  FieldSetWithLiterals,
  SortOrderWithLiterals,
  QueryQuestionEntriesRequestContentFormatWithLiterals,
  QueryQuestionEntriesRequestFieldSetWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  QuestionEntryQuery,
} from './faq-question-entry-v2-question-entry-question-entry.universal.js';
